export const MOBILE_PRO_POPUP_CONTENT = {
  t1: {
    default: "The AMZScout PRO AI Extension is only available for desktop users through the Chrome Web Store.",
    oa: "The AMZScout Dropshipping & Arbitrage Extension is only available for desktop users through the Chrome Web Store.",
    pro: "The AMZScout PRO AI Extension is only available for desktop users through the Chrome Web Store.",
  },
  t3: {
    default: "Do you feel unsure about where to begin?",
    oa: "Do you feel unsure about where to begin?",
    pro: "Go to the AMZScout PRO AI Extension page on the Chrome Store.",
  },
  t4: {
    default: "Start your journey with AMZScout's free courses taught by experienced Amazon sellers!",
    oa: "Start your journey with AMZScout's free courses taught by experienced Amazon sellers!",
    pro: "If you have Chrome Sync, you can install it on your desktop from your phone.",
  },
  l2: {
    default: {
      text: "Proceed to the AMZScout courses",
      link: "/free-amazon-fba-masterclasses/",
    },
    oa: {
      text: "Proceed to the AMZScout courses",
      link: "/free-amazon-fba-masterclasses/",
    },
    pro: {
      text: "Proceed to Chrome Store",
      link: `${process.env.SCOUT_EXT_PRO_NEW}?utm_source=site&utm_medium=amzscout&utm_campaign=mobile_popup`,
    },
  },
};

export const MOBILE_PRO_POPUP_MODES = {
  "/pro/": "pro",
  "/jp/pro/": "pro",
  oa: "oa",
};
